export const INDIGO_GLOBAL_VAR = 'IndigoAIChat';
export const COOKIEHUB_GLOBAL_VAR = 'cookiehub';
